// Keep in sync with the Lighthouse version used by createLighthouseGroundingTool.
// When updating Lighthouse, run the grounding test that asserts this full set.
export const LIGHTHOUSE_ACCESSIBILITY_AUDIT_IDS = [
  "accesskeys",
  "aria-allowed-attr",
  "aria-allowed-role",
  "aria-command-name",
  "aria-conditional-attr",
  "aria-deprecated-role",
  "aria-dialog-name",
  "aria-hidden-body",
  "aria-hidden-focus",
  "aria-input-field-name",
  "aria-meter-name",
  "aria-progressbar-name",
  "aria-prohibited-attr",
  "aria-required-attr",
  "aria-required-children",
  "aria-required-parent",
  "aria-roles",
  "aria-text",
  "aria-toggle-field-name",
  "aria-tooltip-name",
  "aria-treeitem-name",
  "aria-valid-attr-value",
  "aria-valid-attr",
  "button-name",
  "bypass",
  "color-contrast",
  "definition-list",
  "dlitem",
  "document-title",
  "duplicate-id-aria",
  "form-field-multiple-labels",
  "frame-title",
  "heading-order",
  "html-has-lang",
  "html-lang-valid",
  "html-xml-lang-mismatch",
  "image-alt",
  "image-redundant-alt",
  "input-button-name",
  "input-image-alt",
  "label",
  "link-in-text-block",
  "link-name",
  "list",
  "listitem",
  "meta-refresh",
  "meta-viewport",
  "object-alt",
  "select-name",
  "skip-link",
  "tabindex",
  "table-duplicate-name",
  "target-size",
  "td-headers-attr",
  "th-has-data-cells",
  "valid-lang",
  "video-caption",
  "focusable-controls",
  "interactive-element-affordance",
  "logical-tab-order",
  "visual-order-follows-dom",
  "focus-traps",
  "managed-focus",
  "use-landmarks",
  "offscreen-content-hidden",
  "custom-controls-labels",
  "custom-controls-roles",
  "empty-heading",
  "identical-links-same-purpose",
  "landmark-one-main",
  "label-content-name-mismatch",
  "table-fake-caption",
  "td-has-header",
] as const;
